<template>
    <v-dialog v-model="show" persistent no-click-animation width="600">
        <v-card class="AgentInitCallDialog">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('initCall') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar" ref="contentDialog">
                <div class="centerY" style="margin-bottom: 2px; height: 28px;">
                    <div class="label mb-0">Preprocess LUA</div>
                    <div class="btn-icon ml-1" id="btn-add-preprocess-lua" @click="addLuaCard">
                        <img src="/img/add-blue.svg" alt="icon-add-preprocess-lua">
                    </div>
                </div>
                <div v-for="(card, idx) in initLuaCards" :key="`card_${card.name}_${idx}`" class="lua-card">
                    <LuaEditor
                        ref="card"
                        :item.sync="initLuaCards[idx].data"
                        :class="idx > 0 ? 'mt-8' : ''"
                    ></LuaEditor>
                    <div class="btn-delete-lua" v-if="initLuaCards.length > 1"
                         @click="deleteLuaCard(idx)">
                        <img src="/img/delete-new_white.svg" alt="icon-delete-lua" style="width: 17px">
                    </div>
                </div>
            </div>

            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-custom" @click="saveConfig">{{ $f.tc('save') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState} from "vuex"
import lodash from 'lodash'

import LuaEditor from "@/views/Scenario/NodeEditor/common/LuaEditor"
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin"
import FormMixin from "@/modules/fptai/mixins/FormMixin.vue"


export default {
    name: "AgentInitCall",
    components: {LuaEditor},
    mixins: [DialogPromiseMixin, FormMixin],
    data() {
        return {
            initLuaCards: [],
            oldInitLuaCards: [],
        }
    },
    computed: {
        ...mapState({
            initCards: state => state.agent.init_cards
        }),
    },
    methods: {
        open() {
            this.initLuaCards = this.$utils.cloneObject(this.initCards?.value)
            this.oldInitLuaCards = this.initCards?.value
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        saveConfig(isClose = true) {
            // check changes
            if (lodash.isEqual(this.initLuaCards, this.oldInitLuaCards)) {
                this.close()
                this.$appService.toastInfo(this.$f.tc('nothingChanges'))
                return
            }
            this.$store.dispatch(this.$actionTypes.agent.UPDATE_INIT_CARDS, {
                id: this.initCards.id,
                value: this.initLuaCards
            }).then(() => {
                this.oldInitLuaCards = this.$utils.cloneObject(this.initLuaCards)
            }).finally(() => {
                if (isClose) {
                    this.close()
                }
            })
        },
        addLuaCard() {
            this.initLuaCards.push({
                type: "LUA",
                name: 'init',
                data: {
                    script: ''
                }
            })
        },
        deleteLuaCard(index) {
            if (index < 0) return
            this.initLuaCards.splice(index, 1)
        },

        // method for drag and drop
        onCloneCallback(item) {
            return this.$utils.cloneObject(item)
        },
        onMoveCallback(evt) {
            this.dragFrom = evt.draggedContext.element
            this.dragTo = evt.relatedContext.element
            return !this.dragFrom.locked
        },
    },
}
</script>

<style scoped lang="scss">
.AgentInitCallDialog {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        max-height: 560px;
        padding: 12px;
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }

    .lua-card {
        z-index: 3;
        position: relative;

        &:hover .btn-delete-lua {
            visibility: visible;
        }

        .btn-delete-lua {
            z-index: 3;
            visibility: hidden;
            position: absolute;
            right: 0;
            top: 0;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background: #dc3545;
            transition: 0.3s;
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .CodeMirror {
        height: 200px !important;
    }

    .CodeMirror-gutters {
        left: 0 !important;
        width: 29px !important;
    }

    .CodeMirror-gutter-wrapper {
        left: -30px !important;
    }

    .CodeMirror-sizer {
        margin-left: 30px !important;
    }

    .CodeMirror-cursor {
        height: 20px !important;
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-input--switch {
        .v-messages {
            min-height: 0 !important;
        }
    }
}

</style>
